export default "__VITE_ASSET__DjR_cSRv__"